module.exports = __webpack_public_path__ + "img/aprovechar-las-oportunidades.16b4f1d.webp";